module.exports = __webpack_public_path__ + "static/media/welcomeLayoutImage.80c96916.svg";